// Models
/**
 * List of known extension keys for the dependency resource
 */ export var DependencyExtensionKeys = /*#__PURE__*/ function(DependencyExtensionKeys) {
    return DependencyExtensionKeys;
}({});
